import { c as _c } from "react/compiler-runtime";
import { CommonButton } from '@components/common-button/CommonButton';
import linkArrow from '@images/svg/linkArrow.svg';
import { setEqualizerOpened, setSelectedBenefit } from '@lib/store/slices/EqualizerSlice';
import formatLongPrice from '@lib/tools/_format-long-price';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PaymentCard.module.scss';
const PaymentCard = t0 => {
  const $ = _c(52);
  const {
    benefit,
    validMortgageBenefits
  } = t0;
  const dispatch = useDispatch();
  const {
    currentData,
    selectedBenefit
  } = useSelector(_temp);
  const showButton = selectedBenefit?.group === benefit?.group;
  let t1;
  if ($[0] !== benefit || $[1] !== currentData.currentMortgageBenefit || $[2] !== dispatch) {
    t1 = name => {
      if (name === "mortgage") {
        dispatch(setSelectedBenefit(currentData.currentMortgageBenefit));
      } else {
        dispatch(setSelectedBenefit(benefit));
      }
    };
    $[0] = benefit;
    $[1] = currentData.currentMortgageBenefit;
    $[2] = dispatch;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleChoose = t1;
  let t2;
  if ($[4] !== currentData.currentMortgageBenefit || $[5] !== dispatch) {
    t2 = () => {
      dispatch(setSelectedBenefit(currentData.currentMortgageBenefit));
      dispatch(setEqualizerOpened(true));
    };
    $[4] = currentData.currentMortgageBenefit;
    $[5] = dispatch;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleClick = t2;
  let t3;
  if ($[7] !== dispatch || $[8] !== validMortgageBenefits[0]) {
    t3 = () => {
      dispatch(setSelectedBenefit(validMortgageBenefits[0]));
      dispatch(setEqualizerOpened(true));
    };
    $[7] = dispatch;
    $[8] = validMortgageBenefits[0];
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleClickChoice = t3;
  const minPrice = currentData?.currentMortgageBenefit?.mortgage?.minPrice;
  const firstPayment = currentData?.currentMortgageBenefit?.mortgage?.firstPayment;
  const minMonthFee = currentData.currentMinMonthFee ? currentData.currentMinMonthFee : benefit?.mortgage?.minMonthFee;
  const isEnoughFirstPayment = selectedBenefit?.group === "mortgage" && firstPayment >= minPrice;
  let t4;
  if ($[10] !== benefit.group || $[11] !== isEnoughFirstPayment || $[12] !== minMonthFee) {
    t4 = () => {
      if (benefit?.group === "mortgage") {
        if (isEnoughFirstPayment) {
          if (minMonthFee) {
            return <p className={styles.flatBenefit__description}><span>{formatLongPrice(minMonthFee)} ₽</span> в месяц</p>;
          }
        } else {
          return <p className={styles.flatBenefit__lowPayment}>Недостаточный первоначальный взнос</p>;
        }
      }
      return null;
    };
    $[10] = benefit.group;
    $[11] = isEnoughFirstPayment;
    $[12] = minMonthFee;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const renderDescription = t4;
  let t5;
  if ($[14] !== benefit.bestPrice || $[15] !== benefit.description || $[16] !== benefit.discountCustom || $[17] !== benefit.discountPercentCustom || $[18] !== benefit.group) {
    t5 = () => {
      if (benefit?.group === "cash" && benefit?.bestPrice) {
        return <div className={styles.block_bestPrice}><SafeHtmlRenderer className={styles.flatBenefit__description} content={benefit?.description || ""} tag="div" /><div className={styles.flatBenefit__bestPrice}><span className={styles.flatBenefit__bestPriceText}>Выгода</span><div className={styles.flatBenefit__amountWrapper}><p className={styles.flatBenefit__bestPriceAmount}>{formatLongPrice(benefit.discountCustom)} ₽</p><span>-{benefit?.discountPercentCustom}%</span></div></div></div>;
      }
      return null;
    };
    $[14] = benefit.bestPrice;
    $[15] = benefit.description;
    $[16] = benefit.discountCustom;
    $[17] = benefit.discountPercentCustom;
    $[18] = benefit.group;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const renderBestPrice = t5;
  if (benefit.group === "choice-mortgage") {
    const t6 = benefit?.name;
    let t7;
    if ($[20] !== handleClickChoice || $[21] !== t6) {
      t7 = <CommonButton className={styles.benefitSection__openBtn} handleFunction={handleClickChoice} text={t6} icon={linkArrow} />;
      $[20] = handleClickChoice;
      $[21] = t6;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    return t7;
  }
  const t6 = `${styles.flatBenefit} ${showButton ? styles.flatBenefit_selected : ""}`;
  let t7;
  if ($[23] !== benefit.group || $[24] !== handleChoose) {
    t7 = () => handleChoose(benefit?.group ?? "");
    $[23] = benefit.group;
    $[24] = handleChoose;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const t8 = benefit?.group === "mortgage" && currentData.currentMortgageBenefit?.name ? currentData.currentMortgageBenefit?.name : benefit?.name;
  let t9;
  if ($[26] !== t8) {
    t9 = <span>{t8}</span>;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const t10 = `${styles.flatBenefit__checkbox} ${showButton ? styles.flatBenefit__checkbox_selected : ""}`;
  let t11;
  if ($[28] !== t10) {
    t11 = <div className={t10} />;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t7 || $[32] !== t9) {
    t12 = <div className={styles.flatBenefit__btn} onClick={t7}>{t9}{t11}</div>;
    $[30] = t11;
    $[31] = t7;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== renderBestPrice || $[35] !== showButton) {
    t13 = showButton && renderBestPrice();
    $[34] = renderBestPrice;
    $[35] = showButton;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== renderDescription || $[38] !== showButton) {
    t14 = showButton && renderDescription();
    $[37] = renderDescription;
    $[38] = showButton;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== benefit.group || $[41] !== handleClick || $[42] !== showButton) {
    t15 = benefit?.group === "mortgage" && showButton && <button className={styles.flatBenefit__changeBtn} onClick={() => handleClick()}>Изменить условия ипотеки</button>;
    $[40] = benefit.group;
    $[41] = handleClick;
    $[42] = showButton;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t15) {
    t16 = <>{t15}</>;
    $[44] = t15;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t12 || $[47] !== t13 || $[48] !== t14 || $[49] !== t16 || $[50] !== t6) {
    t17 = <div className={t6}>{t12}{t13}{t14}{t16}</div>;
    $[46] = t12;
    $[47] = t13;
    $[48] = t14;
    $[49] = t16;
    $[50] = t6;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  return t17;
};
export default PaymentCard;
function _temp(state) {
  return state?.equalizer;
}